export class CompaniesModel {
    ManufacturerUid: string = '';
    CompanyName: string = '';
    CompanyLogo: string = '';
    CompanyLogoName: string = '';
    CompanyWebUrl: string = '';
    IsFast: number = 0;
    SupportForBim: number = 0;

    constructor(category?: {
        ManufacturerUid: string;
        CompanyName: string;
        CompanyLogo: string;
        CompanyLogoName: string;
        CompanyWebUrl: string;
        IsFast: number;
        SupportForBim: number;
    }) {
        if (category !== undefined) {
            this.ManufacturerUid = category.ManufacturerUid;
            this.CompanyName = category.CompanyName;
            this.CompanyLogo = category.CompanyLogo;
            this.CompanyLogoName = category.CompanyLogoName;
            this.CompanyWebUrl = category.CompanyWebUrl;
            this.IsFast = category.IsFast;
            this.SupportForBim = category.SupportForBim;
        }
    }
}

export class CompanyInfoModel {
    ManufacturerUid: string = '';
    CompanyName: string = '';
    CompanyLogoName: string = '';
    PseudoCompanyLogoName: string = '';
    BimImageName: string = '';
    PseudoBimImageName: string = '';
    CompanyShortName: string = '';
    CompanyInfoLong: string = '';
    CompanyWebUrl: string = '';
    Priority: number = 0;
    IsFollowed: number = 0;
    constructor(category?: {
        ManufacturerUid: string;
        CompanyName: string;
        CompanyLogoName: string;
        PseudoCompanyLogoName: string;
        BimImageName: string;
        PseudoBimImageName: string;
        CompanyShortName: string;
        CompanyInfoLong: string;
        CompanyWebUrl: string;
        Priority: number;
        IsFollowed: number;
    }) {
        if (category !== undefined) {
            this.ManufacturerUid = category.ManufacturerUid;
            this.CompanyName = category.CompanyName;
            this.CompanyLogoName = category.CompanyLogoName;
            this.PseudoCompanyLogoName = category.PseudoCompanyLogoName;
            this.BimImageName = category.BimImageName;
            this.PseudoBimImageName = category.PseudoBimImageName;
            this.CompanyShortName = category.CompanyShortName;
            this.CompanyInfoLong = category.CompanyInfoLong;
            this.CompanyWebUrl = category.CompanyWebUrl;
            this.Priority = category.Priority;
            this.IsFollowed = category.IsFollowed;
        }
    }
}

export class CompanyDataRequest {
    ManufacturerUid: string = '';
    CategoryId: number = 0;
    CompanyShortName: string = '';
    Offset: number = 0;
    PageSize: number = 0;
    Language: string = '';
    SearchText: string = '';
    CountryId: string = '';
    IsCurrentYear: boolean | null = null;
    SearchString: string = '';
    constructor(company?: {
        ManufacturerUid: string;
        CategoryId: number;
        CompanyShortName: string;
        Offset: number;
        PageSize: number;
        Language: string;
        SearchText: string;
        CountryId: string;
        IsCurrentYear: boolean | null;
        SearchString: string;
    }) {
        if (company !== undefined) {
            this.ManufacturerUid = company.ManufacturerUid;
            this.CategoryId = company.CategoryId;
            this.CompanyShortName = company.CompanyShortName;
            this.Offset = company.Offset;
            this.PageSize = company.PageSize;
            this.Language = company.Language;
            this.SearchText = company.SearchText;
            this.CountryId = company.CountryId;
            this.IsCurrentYear = company.IsCurrentYear;
            this.SearchString = company.SearchString;
        }
    }
}

export class CompanyNewsModel {
    NewsUid: string = '';
    NewsType: string = '';
    PseudoImageName: string = '';
    OriginalImageName: string = '';
    NewsTitle: string = '';
    SearchTitle: string = '';
    CompanyName: string = '';
    CreatedDate: any;
    PublishedOn: any;
    TotalNews: number = 0;
    constructor(news?: {
        NewsUid: string;
        NewsType: string;
        PseudoImageName: string;
        OriginalImageName: string;
        NewsTitle: string;
        SearchTitle: string;
        CompanyName: string;
        CreatedDate: any;
        PublishedOn: any;
        TotalNews: number;
    }) {
        if (news !== undefined) {
            this.NewsUid = news.NewsUid;
            this.NewsType = news.NewsType;
            this.PseudoImageName = news.PseudoImageName;
            this.OriginalImageName = news.OriginalImageName;
            this.SearchTitle = news.SearchTitle;
            this.CompanyName = news.CompanyName;
            this.CreatedDate = news.CreatedDate;
            this.PublishedOn = news.PublishedOn;
            this.TotalNews = news.TotalNews;
        }
    }
}

export class CompanyVideoModel {
    VideoUid: string = '';
    GroupName: string = '';
    Title: string = '';
    SearchTitle: string = '';
    VideoLink: string = '';
    CreatedOn: any;
    TotalVideos: number = 0;
    IsCurrentYear: boolean = true;
    constructor(video?: {
        VideoUid: string;
        GroupName: string;
        Title: string;
        SearchTitle: string;
        VideoLink: string
        CreatedOn: any;
        TotalVideos: number;
        IsCurrentYear: boolean;
    }) {
        if (video !== undefined) {
            this.VideoUid = video.VideoUid;
            this.GroupName = video.GroupName;
            this.Title = video.Title;
            this.SearchTitle = video.SearchTitle;
            this.VideoLink = video.VideoLink;
            this.CreatedOn = video.CreatedOn;
            this.TotalVideos = video.TotalVideos;
            this.IsCurrentYear = video.IsCurrentYear;
        }
    }
}

export class ContactDetailsModel {
    CountryCode: number = 0;
    ContactNumber: string = '';
    Email: string = '';
    CompanyName: string = '';
    Address: string = '';
    CompanyInstagramURL: string = '';
    CompanyFacebookURL: string = '';
    CompanyLinkedInURL: string = '';
    CompanyYoutubeURL: string = '';
    constructor(contact?: {
        CountryCode: number;
        ContactNumber: string;
        Email: string;
        CompanyName: string;
        Address: string;
        CompanyInstagramURL: string;
        CompanyFacebookURL: string;
        CompanyLinkedInURL: string;
        CompanyYoutubeURL: string;
    }) {
        if (contact !== undefined) {
            this.CountryCode = contact.CountryCode;
            this.ContactNumber = contact.ContactNumber;
            this.Email = contact.Email;
            this.CompanyName = contact.CompanyName;
            this.Address = contact.Address;
            this.CompanyInstagramURL = contact.CompanyInstagramURL;
            this.CompanyFacebookURL = contact.CompanyFacebookURL;
            this.CompanyLinkedInURL = contact.CompanyLinkedInURL;
            this.CompanyYoutubeURL = contact.CompanyYoutubeURL;
        }
    }
}

export class CompanyNewsDetailsModel {
    ManufacturerUid: string = '';
    NewsUid: string = '';
    NewsTitle: string = '';
    PseudoImageName: string = '';
    OriginalImageName: string = '';
    Description: string = '';
    CompanyName: string = '';
    CompanyShortName: string = '';
    PseudoCompanyLogoName: string = '';
    CompanyLogoName: string = '';
    IsFollowed: number = 0;
    IsLiked: boolean = false;
    IsSaved: boolean = false;
    MatchedSearchTitle: string = '';
    MatchedLang: any = '';
    PublishedOn: Date = new Date();

    constructor(company?: {
        ManufacturerUid: string;
        NewsUid: string;
        NewsTitle: string;
        PseudoImageName: string;
        OriginalImageName: string;
        Description: string;
        CompanyName: string;
        CompanyShortName: string;
        PseudoCompanyLogoName: string;
        CompanyLogoName: string;
        IsFollowed: number;
        IsLiked: boolean;
        IsSaved: boolean;
        MatchedSearchTitle: string;
        MatchedLang: any;
        PublishedOn: Date;
    }) {
        if (company !== undefined) {
            this.ManufacturerUid = company.ManufacturerUid;
            this.NewsUid = company.NewsUid;
            this.NewsTitle = company.NewsTitle;
            this.PseudoImageName = company.PseudoImageName;
            this.OriginalImageName = company.OriginalImageName;
            this.Description = company.Description;
            this.CompanyName = company.CompanyName;
            this.CompanyShortName = company.CompanyShortName;
            this.PseudoCompanyLogoName = company.PseudoCompanyLogoName;
            this.CompanyLogoName = company.CompanyLogoName;
            this.IsFollowed = company.IsFollowed;
            this.IsLiked = company.IsLiked;
            this.IsSaved = company.IsSaved;
            this.MatchedSearchTitle = company.MatchedSearchTitle;
            this.MatchedLang = company.MatchedLang;
            this.PublishedOn = company.PublishedOn;
        }
    }
}

export type FeatureValue = boolean | string | { icon?: boolean; text: string; count?: number; customText?: string | Record<string, string> };

export class PlanFeaturesModel {
    [key: string]: FeatureValue;

    constructor(data?: Record<string, FeatureValue>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class CompanyPlanModel {
    PlanUid: string = '';
    PlanName: string = '';
    PriceLabel: string = '';
    IsFree: number = 0;
    Features: PlanFeaturesModel = new PlanFeaturesModel();

    constructor(data?: {
        PlanUid: string;
        PlanName: string;
        PriceLabel: string;
        IsFree: number;
        Features: Record<string, FeatureValue>;
    }) {
        if (data) {
            this.PlanUid = data.PlanUid;
            this.PlanName = data.PlanName;
            this.PriceLabel = data.PriceLabel;
            this.IsFree = data.IsFree;
            this.Features = new PlanFeaturesModel(data.Features);
        }
    }
}

export class PlanChangeRequestModel {
    RequestId: string = '';
    UserUid: string = '';
    UserName: string = '';
    CompanyName: string = '';
    CompanyEmail: string = '';
    CompanyContact: string = '';
    CurrentPlanUid: string = '';
    CurrentPlan: string = '';
    CurrentPlanPrice: string = '';
    RequestedPlanId: number = 0;
    RequestedPlan: string = '';
    RequestedPlanPrice: string = '';
    ChangeType: string = '';
    SelectedLang: string = '';
    AnalyticsCountries: CompanyPlanCountryModel[] = [];

    constructor(data?: {
        RequestId: string;
        UserUid: string;
        UserName: string;
        CompanyName: string;
        CompanyEmail: string;
        CompanyContact: string;
        CurrentPlanUid: string;
        CurrentPlan: string;
        CurrentPlanPrice: string;
        RequestedPlanId: number;
        RequestedPlan: string;
        RequestedPlanPrice: string;
        ChangeType: string;
        SelectedLang: string;
        AnalyticsCountries: CompanyPlanCountryModel[];

    }) {
        if (data) {
            this.RequestId = data.RequestId;
            this.UserUid = data.UserUid;
            this.UserName = data.UserName;
            this.CompanyName = data.CompanyName;
            this.CompanyEmail = data.CompanyEmail;
            this.CompanyContact = data.CompanyContact;
            this.CurrentPlanUid = data.CurrentPlanUid;
            this.CurrentPlan = data.CurrentPlan;
            this.CurrentPlanPrice = data.CurrentPlanPrice;
            this.RequestedPlanId = data.RequestedPlanId;
            this.RequestedPlan = data.RequestedPlan;
            this.RequestedPlanPrice = data.RequestedPlanPrice;
            this.ChangeType = data.ChangeType;
            this.SelectedLang = data.SelectedLang;
            this.AnalyticsCountries = data.AnalyticsCountries;
        }
    }
}


export class FeatureStatusModel {
    PlanId: number = 0;
    FeatureKey: string = '';
    FeatureType: string = '';
    FeatureValue: string = '';
    Limit?: number;
    Used?: number;
    Remaining?: number;
    IsEnabled?: boolean;
    IsExceeded?: boolean;
    Window?: string;
    ResetsInDays?: number;
    Message?: string;

    constructor(featureStatus?: Partial<FeatureStatusModel>) {
        if (featureStatus) {
            Object.assign(this, featureStatus);
        }
    }
}

export class FeatureStatusResponseModel {
    Features: Record<string, FeatureStatusModel> = {};

    constructor(data?: { Features?: Record<string, any> }) {
        if (data?.Features) {
            Object.keys(data.Features).forEach(key => {
                this.Features[key] = new FeatureStatusModel(data.Features![key]);
            });
        }
    }
}

export class InviteComapnyRegistrationModel {
    CompanyName: string = '';
    CompanyMail: string = '';
    UserMail: string = '';
    SelectedLang: string = '';

    constructor(data?: {
        CompanyName: string;
        CompanyMail: string;
        UserMail: string;
        SelectedLang: string;

    }) {
        if (data) {
            this.CompanyName = data.CompanyName;
            this.CompanyMail = data.CompanyMail;
            this.UserMail = data.UserMail;
            this.SelectedLang = data.SelectedLang;

        }
    }
}

export class CompanyPlanCountryModel {
    CountryId: string = '';
    CountryShortName: string = '';
    Country: string = '';
    CountryCode: number = 0;

    constructor(data?: {
        CountryId: string;
        CountryShortName: string;
        Country: string;
        CountryCode: number;

    }) {
        if (data) {
            this.CountryId = data.CountryId;
            this.CountryShortName = data.CountryShortName;
            this.Country = data.Country;
            this.CountryCode = data.CountryCode;
        }
    }
}